import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-17e7cced"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "min-height": "100%"
  }
};
const _hoisted_2 = {
  class: "homebox clearfix"
};
const _hoisted_3 = {
  class: "owin-height"
};
const _hoisted_4 = {
  class: "course-top"
};
const _hoisted_5 = {
  class: "course-main-title"
};
const _hoisted_6 = {
  key: 0,
  class: "line-icon"
};
const _hoisted_7 = {
  key: 1,
  class: "text"
};
const _hoisted_8 = {
  class: "english-name"
};
const _hoisted_9 = {
  class: "course-wrapper"
};
const _hoisted_10 = {
  key: 0,
  class: "menu-list-out"
};
const _hoisted_11 = {
  class: "menu-list"
};
const _hoisted_12 = {
  class: "course-box"
};
const _hoisted_13 = {
  class: "course-filter"
};
const _hoisted_14 = {
  class: "left"
};
const _hoisted_15 = {
  class: "course-total"
};

const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 找到约 ");

const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 条相关结果 ");

const _hoisted_18 = {
  key: 1,
  class: "no-data"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LeftMenuItem = _resolveComponent("LeftMenuItem");

  const _component_el_affix = _resolveComponent("el-affix");

  const _component_VideoCard = _resolveComponent("VideoCard");

  const _component_Empty = _resolveComponent("Empty");

  const _component_el_pagination = _resolveComponent("el-pagination");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [$data.classify_flag !== '1' ? (_openBlock(), _createElementBlock("div", _hoisted_6)) : _createCommentVNode("", true), $data.classify_flag !== '1' ? (_openBlock(), _createElementBlock("span", _hoisted_7, [_createTextVNode(_toDisplayString($data.menuInfo.nav_name) + "  ", 1), _createElementVNode("span", _hoisted_8, _toDisplayString($data.courseType == 1 ? '/ Course Center' : '/  Everyone Gold Class'), 1)])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_9, [$data.organ_flag == 1 || $data.results_flag == 1 || $data.subject_flag == 1 || $data.term_flag == 1 ? (_openBlock(), _createBlock(_component_el_affix, {
    key: 0,
    offset: 80
  }, {
    default: _withCtx(() => [$data.menuDataLoaded ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [$data.organ_flag == 1 && $data.menuDataLoaded ? (_openBlock(), _createBlock(_component_LeftMenuItem, {
      key: 0,
      menuData: $data.categoryData,
      checkedId: $data.searchInfo.collegeId,
      onCheckedChange: $options.collegeChange
    }, null, 8, ["menuData", "checkedId", "onCheckedChange"])) : _createCommentVNode("", true), $data.courseType == 2 && $data.term_flag == 1 && $data.menuDataLoaded ? (_openBlock(), _createBlock(_component_LeftMenuItem, {
      key: 1,
      menuData: $data.termData,
      checkedId: $data.searchInfo.semester,
      onCheckedChange: $options.termChange
    }, null, 8, ["menuData", "checkedId", "onCheckedChange"])) : _createCommentVNode("", true), $data.results_flag == 1 && $data.menuDataLoaded ? (_openBlock(), _createBlock(_component_LeftMenuItem, {
      key: 2,
      menuData: $data.achievementKindData,
      checkedId: $data.searchInfo.courseResultsId,
      onCheckedChange: $options.courseResultChange
    }, null, 8, ["menuData", "checkedId", "onCheckedChange"])) : _createCommentVNode("", true), $data.subject_flag == 1 && $data.menuDataLoaded ? (_openBlock(), _createBlock(_component_LeftMenuItem, {
      key: 3,
      menuData: $data.subjectData,
      checkedId: $data.searchInfo.subjectId,
      onCheckedChange: $options.oneSubjectChange,
      isLast: true
    }, null, 8, ["menuData", "checkedId", "onCheckedChange"])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]),
    _: 1
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("span", null, _toDisplayString($data.pageInfo.rows), 1), _hoisted_17])])]), _createElementVNode("div", null, [$data.courseType == '1' && $data.courseList.length ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["course-list", $data.organ_flag == 2 && $data.results_flag == 2 && $data.subject_flag == 2 ? 'course-list-no' : 'course-list-yes'])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.courseList, course => {
    return _openBlock(), _createBlock(_component_VideoCard, {
      userInfo: $data.userInfo,
      "course-data": course,
      key: course.courseId,
      authType: $data.authType,
      showResultTag: $data.showResultTag,
      resultMap: $data.resultMap
    }, null, 8, ["userInfo", "course-data", "authType", "showResultTag", "resultMap"]);
  }), 128))], 2)) : _createCommentVNode("", true), $data.courseType == 1 && !$data.courseList.length ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_Empty, {
    text: "暂无数据"
  })])) : _createCommentVNode("", true)]), $data.pageInfo.rows > $data.pageInfo.pageLimit ? (_openBlock(), _createBlock(_component_el_pagination, {
    key: 0,
    class: "course-pagination",
    background: "",
    layout: "prev, pager, next",
    "prev-text": "上一页",
    "next-text": "下一页",
    "page-size": $data.pageInfo.pageLimit,
    onCurrentChange: $options.pageIndexChange,
    "current-page": $data.pageInfo.pageIndex,
    total: 0 || $data.pageInfo.rows
  }, null, 8, ["page-size", "onCurrentChange", "current-page", "total"])) : _createCommentVNode("", true)])])])])]);
}